import * as angular from 'angular';
import { config } from 'angular/utils/config';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpTsoLogo
     * @memberof app
     *
     * @restrict E
     *
     * @description
     * Shows the Logos of the TSOs of a unbundled or bundled networkpoint
     *
     * @author somarten.btc
     */
    angular.module('app').directive('pkpTsoLogo', pkpTsoLogo);

    function pkpTsoLogo() {
        return {
            restrict: 'E',
            scope: {
                networkPoint: '='
            },
            template: require('app/_directives/pkp-tso-logo.directive.html'),
            link: linkFn
        };

        function linkFn(scope) {
            scope.stageConfig = config;
        }
    }
})();
